"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringify = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var qs_1 = tslib_1.__importDefault(require("qs"));
/**
 * Stringifies an object to query string. Makes sure arrays are serialized as comma separated, otherwise bear backend does not understand it.
 * @param obj - object to stringify
 * @param options - additional qs.stringify options
 */
exports.stringify = function (obj, options) {
    return qs_1.default.stringify(obj, tslib_1.__assign(tslib_1.__assign({}, options), { arrayFormat: "comma" }));
};
//# sourceMappingURL=queryString.js.map